
import { Injectable, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Subject } from 'rxjs';
@Injectable()
export class AuthService  {
    roles: Array<any> = [];
    checksprigAvailable = new Subject<any>();
    roleAccessSubscription = new Subject<any>();

    constructor(
        private keycloakService: KeycloakService
    ) { }

    public canSchedule() {
       return this.roles.indexOf("canSchedule") <0 ? false : true;      
    }

    checkRequestAccessRole(){
        return this.roles.indexOf('requests') <0 ? false : true;
    }
    checkSubmittedRequestAccessRole(){
        return this.roles.indexOf('approver') <0 ? false : true;
    }
    checkCanSchedules() {
        return this.roles.indexOf('schedules') <0 ? false : true;
    }
    checkSettingsRole(){
        return this.roles.indexOf('settings') <0 ? false : true;
    }
    checkProductlinesRole(){
        return this.roles.indexOf('productlines') <0 ? false : true;
    }
    checkAddressbookRole(){
        return this.roles.indexOf('addressbook') <0 ? false : true;
    }
    checkContactsRole(){
        return this.roles.indexOf('contacts') <0 ? false : true;
    }
    checkProductsRole(){
        return this.roles.indexOf('products') <0 ? false : true;
    }
    checkRequestCertRole(){
        return this.roles.indexOf('requestcert') <0 ? false : true;
    }
    checkProductDocsRole(){
        return this.roles.indexOf('productdocs') <0 ? false : true;
    }
    checkProductMfgRole(){
        return this.roles.indexOf('productmfg') <0 ? false : true;
    }
    canViewNewFeatures() {
        return this.roles.indexOf('canViewNewFeatures') <0 ? false : true;
    }
    checkAdminRole(){
        return this.roles.indexOf('adminRole') <0 ? false : true;
    }

  async checkRoleExist(role){
        if (await this.keycloakService.isLoggedIn()) {
            return this.keycloakService.getUserRoles().indexOf(role) < 0
              ? false
              : true;
          }
    }

    isDiscardQuoteRequestRoute = false;
    canDiscardQuoteRequestRoute(val){
        this.isDiscardQuoteRequestRoute = val;
        console.log(this.isDiscardQuoteRequestRoute)
    }
}